export default __webpack_public_path__ + "static/media/catálogos_updated.e5aa010e.png";